module.exports = __webpack_public_path__ + "img/Super-Simon-SunHero-V1.d653e563.png";